import Mobile from './Mobile';
import Desktop from './Desktop';

export default { Mobile, Desktop };
